import { isUnitConfused } from './friendlyAuraProviderUnits';

/**
 * Unit IDs that provide persistent negative global effects while on the battlefield.
 * Source of truth for negative aura-provider VFX.
 */
export const NEGATIVE_AURA_PROVIDER_UNIT_IDS = Object.freeze([
  109, // Signal Breaker — all strategems cost +2 (stacks)
  502, // Disruptor — all drones inactive
]);

const NEGATIVE_AURA_PROVIDER_UNIT_ID_SET = new Set(NEGATIVE_AURA_PROVIDER_UNIT_IDS);

export function isNegativeAuraProviderUnit(order) {
  if (!order || order.id === undefined || order.id === null) {
    return false;
  }
  const id = Number(order.id);
  if (Number.isNaN(id)) {
    return false;
  }
  return NEGATIVE_AURA_PROVIDER_UNIT_ID_SET.has(id);
}

/**
 * Whether the battlefield negative aura cloud VFX should render for this unit.
 * Mirrors positive aura rules: hide when confused (special effects stripped).
 */
export function shouldShowNegativeAuraCloudEffect(
  order,
  { zoneName, isHiddenDuringAnimation = false } = {}
) {
  if (!zoneName || isHiddenDuringAnimation) {
    return false;
  }
  if (!isNegativeAuraProviderUnit(order)) {
    return false;
  }
  if (isUnitConfused(order)) {
    return false;
  }
  return true;
}
